<template>
  <div>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      v-b-modal.form-district-modal
      @click="cleanUpForm()"
    >
      Tambah
    </b-button>

    <b-modal
      id="form-district-modal"
      no-close-on-backdrop
      size="lg"
      :title="(editId == null ? 'Tambah' : 'Edit') + ' Kecamatan'"
    >
      <validation-observer ref="cityValidation">
        <div class="form">
          <div class="row">
            <div class="col-7">

              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Provinsi</label>
                <div class="col-sm-8">
                  <validation-provider
                    #default="{ errors }"
                    name="provinceId"
                    rules="required"
                  >
                    <v-select size="sm" 
                        placeholder="-- Pilih Provinsi --"
                        v-model="formPayloadDistrict.provinceId"
                        :options="provinceList"
                        :reduce="province => province.value"
                        label="text"
                        v-on:input="getCityData($event)"
                     />
                     <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Kota/Kab</label>
                <div class="col-sm-8">
                  <validation-provider
                    #default="{ errors }"
                    name="cityId"
                    rules="required"
                  >
                    <v-select size="sm" 
                        placeholder="-- Pilih Kota/Kab --"
                        v-model="formPayloadDistrict.cityId"
                        :options="cityList"
                        :reduce="city => city.value"
                        label="text"
                     />
                     <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Nama Kecamatan</label>
                <div class="col-sm-8">
                  <validation-provider
                    #default="{ errors }"
                    name="districtName"
                    rules="required"
                  >
                    <b-form-input
                      v-model="formPayloadDistrict.districtName"
                      :state="validations.districtName ? false : null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Kode Kecamatan</label>
                <div class="col-sm-8">
                  <validation-provider
                    #default="{ errors }"
                    name="districtCode"
                    rules="required"
                  >
                    <b-form-input
                      v-model="formPayloadDistrict.districtCode"
                      :state="validations.districtCode ? false : null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>

              
             

            </div>
          </div>
        </div>
      </validation-observer>

      <template #modal-footer="{}">
        <div v-if="isLoadingProvince">
          <br />
          <b-spinner class="mb-2" variant="primary" /><br />
        </div>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          :disabled="isLoadingProvince"
          @click="submitItem()"
        >
          Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import {
  BButton,
  BSpinner,
  BFormInput,
  BFormFile,
  BFormCheckbox,
  BFormSelect,
  BFormTextarea,
  BImg,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { successNotification, errorNotification } from "@/auth/utils";
import vSelect from "vue-select";

export default {
  components: {
    BButton,
    BSpinner,
    BFormInput,
    BFormCheckbox,
    BFormFile,
    BFormSelect,
    BImg,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    required,
    vSelect,
  },
  directives: {
    Ripple,
  },
  /* eslint-disable vue/require-default-prop */
  props: {
    formPayload: {
      type: "",
    },
    editPayload: {
      type: "",
    },
    isLoading: {
      type: Boolean,
    },
    editId: {
      type: String,
    },
    createItem: {
      type: Function,
    },
    updateItem: {
      type: Function,
    },
    validations: {
      type: "",
    },
    cleanUpForm: {
      type: Function,
    },
    province: {
      type: "",
    },
    city: {
      type: "",
    },
  },
  setup(props) {
    return {
      successNotification,
      errorNotification,
    };
  },
  data() {
    return {
      isLoadingProvince: false,
      formPayloadDistrict: {
        cityCode: "",
        cityName: "",
        provinceId: 0,
        cityId: 0,
      },
      provinceList: [],
      cityList: [],
    };
  },
  watch: {
    isLoading(value) {
      this.isLoadingProvince = value;
    },
    formPayload: {
      handler(value) {
        this.formPayloadDistrict = value;
      },
      deep: true,
    },
    formPayloadDistrict: {
      handler(value) {
        this.$emit("payloadDistrict", value);
      },
      deep: true,
    },
    editPayload(value) {
        if (value.provinceId !== null) {
            this.getCityData(value.provinceId)
        }
    },
    province(value) {
      this.provinceList = value;
    },
    city(value) {
      this.cityList = value;
    },
  },
  methods: {
    submitItem() {
      this.$refs.cityValidation.validate().then((success) => {
        if (success) {
          if (this.editId == null) {
            this.createItem();
          } else {
            this.updateItem();
          }
        }
      });
    },
    getCityData(provinceId) {
      // this.formPayloadDistrict.cityId = ''
      const queryParams = {
        provinceId: provinceId 
      }

      this.$http.get("/mastering/city/all/" + provinceId, {  }).then((response) => {
        let result = response.data.data;

        for (let i = 0; i < result.length; i++) {
          result[i].value = result[i].cityId;
          result[i].text = result[i].cityName;
          delete result[i].key;
          delete result[i].label;
        }

        this.cityList = result;
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
